import { ListFieldSection, SectionGroup } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { hasValue } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, NumericInput, RadioGroup, TextOutput } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { OversizePropertytoCalculate } from '../../types';

let AsOversizeCorrectionDataSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector, prefixName }) => {
  const oversizePropertytoCalculate = useSelector(
    pipe(createWorksheetSelector!('OversizeCorrectionData.OversizePropertytoCalculate'))
  ) as OversizePropertytoCalculate;

  const oversizeDensityHasValue = useSelector(
    pipe(createWorksheetSelector!('OversizeCorrectionData.OversizeDensity'), hasValue)
  );
  const oversizeVolumeHasValue = useSelector(
    pipe(createWorksheetSelector!('OversizeCorrectionData.OversizeVolume'), hasValue)
  );

  return (
    <>
      <SectionGroup>
        <ListFieldSection>
          <Field
            input={<RadioGroup />}
            name={'OversizeCorrectionData.OversizePropertytoCalculate'}
            options={[
              { label: 'Density', value: OversizePropertytoCalculate.Density },
              { label: 'Volume', value: OversizePropertytoCalculate.Volume },
            ]}
            confirm={() =>
              (oversizePropertytoCalculate === OversizePropertytoCalculate.Density && oversizeVolumeHasValue) ||
              (oversizePropertytoCalculate === OversizePropertytoCalculate.Volume && oversizeDensityHasValue)
            }
            confirmText="The oversize property to calculate will be changed, overwriting any existing data."
          />
        </ListFieldSection>
        <ListFieldSection>
          <Field
            input={
              oversizePropertytoCalculate === OversizePropertytoCalculate.Volume ? <TextOutput /> : <NumericInput />
            }
            name="OversizeCorrectionData.OversizeVolume"
          />
          <Field
            input={
              oversizePropertytoCalculate === OversizePropertytoCalculate.Density ? <TextOutput /> : <NumericInput />
            }
            name="OversizeCorrectionData.OversizeDensity"
          />
        </ListFieldSection>
      </SectionGroup>
    </>
  );
};

AsOversizeCorrectionDataSection = withInjectedProps(AsOversizeCorrectionDataSection);

export { AsOversizeCorrectionDataSection };
export default AsOversizeCorrectionDataSection;
